class BannerAktionszeileHeader extends HTMLElement {

    connectedCallback() {
        this.setElements();
        this.bindEvents();
    }

    setElements() {
        this.kopierenButton = this.querySelector('.button-gutscheincode');
        this.gutscheinCode = this.querySelector('.gutscheincode')?.innerHTML;
        this.statusText = this.querySelector('.banner-kopieren-status');
        
        this.overlay = this.querySelector('.overlay-aktionszeile');
        this.overlayOeffnenButton = this.querySelector('.open-overlay-aktionszeile');
        this.overlaySchliessenButtonList = this.querySelectorAll('.close-overlay-aktionszeile');
    }

    bindEvents() {
        this.kopierenButton?.addEventListener('click', () => this.codeKopieren());
        this.overlayOeffnenButton?.addEventListener('click', () => this.overlayOeffnen());
        this.overlaySchliessenButtonList.forEach((button) => {
            button.addEventListener('click', () => this.overlaySchliessen())
        });
    }

    codeKopieren = async () => {
        try {
            await navigator.clipboard.writeText(this.gutscheinCode);
            // console.log('Gutscheindcode ' + this.gutscheinCode + ' kopiert.');
            this.toggleStatusAnzeige();
        } catch (err) {
            // console.error('Fehler beim Kopieren von: ', err);
        }
    }

    toggleStatusAnzeige() {
        // Statustext Einblenden…
        this.statusText?.removeAttribute('hidden');
        // …und wieder ausblenden 
        setTimeout(() => {
            this.statusText?.setAttribute('hidden', 'hidden');
        }, "3000");
    }

    overlayOeffnen() {
        this.overlay.showModal();
    }
  
    overlaySchliessen() {
        this.overlay.close();
    }

}

if (!customElements.get('banner-aktionszeile-header')) {
    customElements.define('banner-aktionszeile-header', BannerAktionszeileHeader);
}
